import React, { useRef } from "react";
import imageCompression from "browser-image-compression";
import LinkButton from "../../../components/Buttons/LinkButton";

type Props = {
  onSelect: (file: any) => void;
  btnIcon: JSX.Element;
  label: string;
};

const UploadFile: React.FC<Props> = ({ onSelect, btnIcon, label }) => {
  const fileInputRef = useRef<any>(null);

  const handleFileChange = async (event: any) => {
    const file = event.target.files[0];
    if (!file) return;
    // const blob = new Blob([file], { type: file.type });
    const options = {
      maxSizeMB: 5,
      maxWidthOrHeight: 1920,
      initialQuality: 0.8,
      useWebWorker: true,
    };
    try {
      const compressedFile = await imageCompression(file, options);
      onSelect(compressedFile);
    } catch (error) {
      console.log(error);
    }
  };

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current?.click();
    }
  };

  return (
    <>
      <LinkButton
        label={label}
        icon={btnIcon}
        style={{ marginTop: "0.625rem" }}
        onClick={handleButtonClick}
      />
      <input
        type='file'
        accept='image/*'
        style={{ display: "none" }}
        ref={fileInputRef}
        onChange={handleFileChange}
      />
    </>
  );
};

export default UploadFile;
